import { cva, type VariantProps } from 'class-variance-authority'
import type { ComponentProps } from 'react'
import * as React from 'react'
import { cn } from '@/src/utils/styles'

const textareaVariants = cva(
  'flex bg-transparent text-input-text focus-visible:outline-none disabled:opacity-50 disabled:pointer-events-none transition-all',
  {
    variants: {
      dimension: {
        small: 'min-h-20 rounded-[8px] py-1.5 px-3 text-sm leading-5',
        medium: 'min-h-24 rounded-xl py-3 px-4',
        large: 'min-h-28 rounded-2xl py-4 px-5',
      },
      variant: {
        default:
          'outline outline-1 outline-input-border placeholder:text-input-placeholder hover:outline-2 hover:outline-input-border-hover hover:placeholder:text-input-placeholder-hover focus-visible:ring-2 focus-visible:ring-focus focus-visible:placeholder:text-input-border',
        ghost: 'p-0 rounded-none',
      },
    },
    defaultVariants: {
      dimension: 'medium',
      variant: 'default',
    },
  },
)

interface TextareaProps
  extends ComponentProps<'textarea'>,
    VariantProps<typeof textareaVariants> {
  isValid?: boolean
  isInvalid?: boolean
  containerClassName?: string
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  (
    {
      className,
      dimension,
      variant,
      isValid,
      isInvalid,
      containerClassName,
      ...props
    },
    ref,
  ) => {
    return (
      <div className={cn('flex w-full relative', containerClassName)}>
        <textarea
          className={cn(
            textareaVariants({ dimension, variant, className }),
            'w-full',
            isInvalid && 'outline-danger-text hover:outline-danger-text',
          )}
          ref={ref}
          rows={3}
          {...props}
        />
      </div>
    )
  },
)

Textarea.displayName = 'Textarea'

export { Textarea }
